export const VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
export const VAR_SCROLL_INDICATOR_COLOR = '--ds-menu-scroll-indicator-color';
